// @flow

import * as React from 'react';
import styled from 'styled-components';

type Props = {
  panelIsHidden: boolean,
  onClick?: Function,
  onMouseDown?: Function,
  id: string,
  Icon: Function,
  label: string,
};

export default class ServiceBarItem extends React.Component<Props> {
  render() {
    const { panelIsHidden, onClick, onMouseDown, id, Icon, label } = this.props;
    return (
      <ButtonListItem panelIsHidden={panelIsHidden}>
        <ButtonLink onClick={onClick} onMouseDown={onMouseDown} id={id}>
          <IconContainer>
            <Icon />
          </IconContainer>
          <ButtonSpan>{label}</ButtonSpan>
        </ButtonLink>
      </ButtonListItem>
    );
  }
}

const ButtonListItem = styled.li`
  position: relative;
  display: inline-block;
  background-color: #fff;
  background-image: linear-gradient(-180deg, #fff, #fafafa);
  width: 80px;
  height: 70px;
  user-select: none;
  border-radius: ${(props) =>
    props.panelIsHidden ? '4px 0 0 4px' : '0 0 0 4px'};
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;

  &:first-of-type {
    border-radius: 4px 0 0 4px;
    border-left: 1px solid #e5e5e5;
    border-right: ${(props) =>
      props.panelIsHidden ? '0' : '1px solid #e5e5e5'};
    border-top: ${(props) =>
      props.panelIsHidden ? '1px solid #e5e5e5' : '1px solid #fff'};
    border-bottom: ${(props) =>
      props.panelIsHidden ? '1px solid #e5e5e5' : '0'};
    border-top-left-radius: ${(props) => (props.panelIsHidden ? '4px' : '0')};
  }
`;

const ButtonLink = styled.div`
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
  color: inherit;
  width: 100%;
  height: 100%;
  border-radius: 0;
  line-height: 1;
  cursor: pointer;
  transition:
    color 0.1s ease-in-out,
    opacity 0.1s ease-in-out;
  text-decoration: none;
  background-color: transparent;
  ${ButtonListItem}:hover & {
    background-color: #e0eef4;
  }
  font-size: 0.75rem;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 12px 0;
`;

const ButtonSpan = styled.span`
  position: absolute;
  display: block;
  width: 100%;
  bottom: 12px;
  margin: 0;
  left: 50%;
  -ms-transform: translate(-50%);
  transform: translate(-50%);
  text-align: center;
  font-family: DanskeTextv2, Verdana, sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
`;
